import NotificationIndicator from './NotificationIndicator';

export default NotificationIndicator;
